<template>
    <label class="forms__field_label" :class="sizeClass" :for="props.for">
        <span v-if="props.value">{{ props.value }}</span>
        <span v-else><slot></slot></span>
    </label>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { Ref } from 'vue';
import { ComponentSize } from '@src/Common/DataGrid/types';

interface Props {
    value?: string | null;
    size?: ComponentSize;
    for?: string | undefined;
}

const props = withDefaults(defineProps<Props>(), {
    value: null,
    size: 'base',
    for: undefined,
});

const sizeClass: Ref<string> = computed((): string => {
    const sizes = {
        xs: 'forms__field_label--xs',
        sm: 'forms__field_label--sm',
        base: 'forms__field_label--base',
        lg: 'forms__field_label--lg',
        xl: 'forms__field_label--xl',
    };

    return sizes[props.size] ?? sizes.base;
});
</script>
